import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            //TODO: cleanup when all dependencies are handled
            path: 'mobileportal/:pathMatch',
            redirectTo: 'myaccount/:pathMatch',
            pathMatch: 'prefix',
        },
    ],
};

export default routes;
